import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import './ArrayDialogEditor.scss';

// https://material-ui.com/api/checkbox/
// Checkbox do not support undefined as a value as this value is letter converted into a DOM string
const UNDEFINED_CHECK_VALUE = '__undefined_check_value__';

const ArrayDialogEditor = (props) => {
  const { value, onValueChange, editor } = props;
  const [namedValues] = useState(() => {
    return Array.isArray(editor.namedValues) ? editor.namedValues : editor.namedValues(props);
  });
  const handleChange = (event) => {
    const checkValue = event.target.value === UNDEFINED_CHECK_VALUE ? undefined : event.target.value;
    if (editor.toggle) {
      onValueChange(editor.toggle(checkValue, value));
    } else if (checkValue === undefined) {
      onValueChange(undefined);
    } else if (value === undefined) {
      onValueChange([checkValue]);
    } else {
      const index = value.indexOf(checkValue);
      if (index < 0) {
        onValueChange(value.concat(checkValue), editor);
      } else {
        const res = value.slice();
        res.splice(index, 1);
        onValueChange(res.length && res || undefined, editor);
      }
    }
  };
  const isChecked = editor.isChecked || ((checkValue) => {
    return (value === undefined) || (checkValue === undefined)
        ? (checkValue === value) : (value.indexOf(checkValue) >= 0);
  });

  return (
    <FormControl component="fieldset" className="grbrsm-array-dialog-editor">
      <FormGroup>
        {namedValues.map(tr => (
          <FormControlLabel
            key={tr.label}
            control={(
              <Checkbox
                checked={isChecked(tr.value)}
                onChange={handleChange}
                value={tr.value === undefined ? UNDEFINED_CHECK_VALUE : tr.value}
              />
            )}
            label={tr.label}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

ArrayDialogEditor.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({}),
    ]),
  ),
  editor: PropTypes.shape({
    toggle: PropTypes.func,
    isChecked: PropTypes.func,
    namedValues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  onValueChange: PropTypes.func.isRequired,
};

ArrayDialogEditor.defaultProps = {
  value: undefined,
};

export default ArrayDialogEditor;
